module.exports = __webpack_public_path__ + "static/media/wip.407ce1fb.png";